import { useMemo, useState } from 'react';

export default function usePagination(total: number, options: { pageSize: number }) {
  const PER_PAGE = options.pageSize; // limit
  const [pageIndex, setPageIndex] = useState(0); // page

  const pageCount = useMemo(() => {
    return Math.ceil(total / PER_PAGE) || 0;
  }, [total, PER_PAGE]);

  const offset = useMemo(() => {
    return calcOffset(pageIndex);
  }, [pageIndex]);

  function calcOffset(pageIdx: number) {
    return pageIdx * PER_PAGE;
  }

  return {
    pageCount,
    pageIndex,
    offset,
    setPageIndex: (idx: number) => {
      setPageIndex(idx);
      return calcOffset(idx);
    },
  };
}
